// Safari before 15.4 drops every @layer block, which is nearly all of Tailwind's CSS. Inlined in
// the document head, this adds the build's flattened `*.legacy.css` copy (vite.config.ts) next to
// each stylesheet, including ones lazy chunks add later, but only where cascade layers are missing.
export const cascadeLayersFallbackScript = String.raw`(function () {
  if (window.CSSLayerBlockRule) return;
  var added = {};
  function addFlattenedCopy(link) {
    if (link.rel !== "stylesheet" || !/\/assets\/[^\/?#]+\.css$/.test(link.href)) return;
    if (/\.legacy\.css$/.test(link.href) || added[link.href]) return;
    added[link.href] = true;
    var copy = document.createElement("link");
    copy.rel = "stylesheet";
    copy.href = link.href.replace(/\.css$/, ".legacy.css");
    link.after(copy);
  }
  document.querySelectorAll('link[rel="stylesheet"]').forEach(addFlattenedCopy);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeName === "LINK") addFlattenedCopy(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();`;
